// Global quantity selector handler
document.addEventListener("DOMContentLoaded", function () {
  // Find all forms that might have quantity selectors
  const productForms = document.querySelectorAll(
    'form[data-type="add-to-cart-form"]'
  );

  productForms.forEach((form) => {
    // Find quantity inputs associated with this form
    const formId = form.id;
    const quantityInputs = document.querySelectorAll(
      `input[name="quantity"][form="${formId}"], .modern-quantity-selector .quantity-input[form="${formId}"]`
    );

    if (quantityInputs.length === 0) return;

    // Override form submission
    form.addEventListener("submit", function (e) {
      // Get the first visible quantity input
      const activeQuantityInput = quantityInputs[0];
      const quantity = parseInt(activeQuantityInput.value) || 1;

      // Remove any existing hidden quantity inputs
      form
        .querySelectorAll('input[type="hidden"][name="quantity"]')
        .forEach((input) => {
          input.remove();
        });

      // Create a new hidden input with the current quantity
      const qtyInput = document.createElement("input");
      qtyInput.type = "hidden";
      qtyInput.name = "quantity";
      qtyInput.value = quantity;

      // Add the hidden input to the form
      form.appendChild(qtyInput);
    });
  });

  // Handle responsive product titles
  function handleResponsiveProductTitles() {
    const productTitles = document.querySelectorAll(
      ".shop-product-title[data-font-size][data-mobile-font-size]"
    );

    productTitles.forEach((title) => {
      function adjustTitleFontSize() {
        const desktopSize = title.getAttribute("data-font-size");
        const mobileSize = title.getAttribute("data-mobile-font-size");

        if (window.innerWidth <= 767) {
          title.style.setProperty("font-size", `${mobileSize}px`, "important");
        } else {
          title.style.setProperty("font-size", `${desktopSize}px`, "important");
        }
      }

      // Run immediately
      adjustTitleFontSize();

      // Add resize event listener if not already added
      if (!title.hasAttribute("data-resize-listener-added")) {
        window.addEventListener("resize", adjustTitleFontSize);
        title.setAttribute("data-resize-listener-added", "true");
      }
    });
  }

  // Initialize responsive product titles
  handleResponsiveProductTitles();

  // Handle FAQ accordions
  function initFaqAccordions() {
    const faqContainers = document.querySelectorAll(".product-faq");

    faqContainers.forEach((faqContainer) => {
      const faqId = faqContainer.id;
      if (!faqId) return;

      const faqItems = faqContainer.querySelectorAll(".faq-item");
      const innerFaqContainer = faqContainer.querySelector(".faq-container");
      const isAccordion =
        innerFaqContainer &&
        innerFaqContainer.getAttribute("data-accordion") === "true";

      faqItems.forEach((item) => {
        const question = item.querySelector(".faq-question");
        if (!question) return;

        // Only add click listener if it doesn't already have one
        if (!question.hasAttribute("data-click-listener-added")) {
          question.setAttribute("data-click-listener-added", "true");

          question.addEventListener("click", () => {
            const isActive = item.classList.contains("active");

            // Close all other items first if accordion mode is enabled
            if (isAccordion && !isActive) {
              faqItems.forEach((otherItem) => {
                otherItem.classList.remove("active");
              });
            }

            // Toggle the clicked item
            item.classList.toggle("active");
          });
        }
      });
    });
  }

  // Initialize FAQ accordions
  initFaqAccordions();

  // Initialize product gallery functionality
  initProductGallery();

  // Listen for variant image changes
  document.addEventListener("variant:imageChanged", function (event) {
    if (event.detail && event.detail.image) {
      const galleryWasFiltered =
        typeof window.filterShopProductGalleryByColor === "function" &&
        window.filterShopProductGalleryByColor(
          event.detail.color,
          event.detail.image,
        );

      if (!galleryWasFiltered) {
        updateGalleryWithVariantImage(event.detail.image);
      }
    }
  });
});

// Other product details JavaScript can go here

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    document.querySelectorAll(".kaching-bundles__bar").forEach(function (bar) {
      bar.addEventListener("click", function () {
        // Get pricing values
        const pricingContainer = bar.querySelector(
          ".kaching-bundles__bar-pricing"
        );
        const priceElement = pricingContainer.querySelector(
          ".kaching-bundles__bar-price"
        );
        const fullPriceElement = pricingContainer.querySelector(
          ".kaching-bundles__bar-full-price"
        );

        const price = priceElement ? priceElement.textContent.trim() : null;
        const fullPrice = fullPriceElement
          ? fullPriceElement.textContent.trim()
          : null;

        // Find parent product info block
        const productInfo = bar.closest(".shop-product-info");

        if (productInfo && price && fullPrice) {
          const buttonTextContainer = productInfo.querySelector(
            ".shop-add-to-cart-button .button-text"
          );
          if (buttonTextContainer) {
            setTimeout(function () {
              buttonTextContainer.innerHTML = `Add to Cart - ${price} <span class="compare-price">${fullPrice}</span>`;
            }, 50);
          }
        }
      });
    });
  }, 1000);
});

function initProductGallery() {
  function cloneWithoutEventListeners(element) {
    const clone = element.cloneNode(true);
    element.replaceWith(clone);
    return clone;
  }

  const imageWrapper = document.querySelector(".shop-main-image-wrapper");
  if (imageWrapper) cloneWithoutEventListeners(imageWrapper);

  const mainImages = Array.from(document.querySelectorAll(".shop-main-image"));
  const thumbnails = Array.from(document.querySelectorAll(".shop-thumbnail")).map(
    cloneWithoutEventListeners,
  );
  const previousArrow = document.querySelector(".shop-prev-arrow");
  const nextArrowElement = document.querySelector(".shop-next-arrow");
  const prevArrow = previousArrow
    ? cloneWithoutEventListeners(previousArrow)
    : null;
  const nextArrow = nextArrowElement
    ? cloneWithoutEventListeners(nextArrowElement)
    : null;

  if (!mainImages.length || !thumbnails.length || !prevArrow || !nextArrow) {
    return;
  }

  let visibleIndexes = mainImages.map((_image, index) => index);
  let currentVariantImage = null;
  let currentIndex = Math.max(
    mainImages.findIndex((image) => image.classList.contains("active")),
    0,
  );

  function updateArrowStates() {
    const disableNavigation = visibleIndexes.length <= 1;
    prevArrow.classList.toggle("disabled", disableNavigation);
    nextArrow.classList.toggle("disabled", disableNavigation);
    prevArrow.setAttribute("aria-disabled", String(disableNavigation));
    nextArrow.setAttribute("aria-disabled", String(disableNavigation));
  }

  function changeImage(index) {
    if (!visibleIndexes.includes(index)) return;

    mainImages.forEach((image, imageIndex) => {
      const isActive = imageIndex === index;
      image.classList.toggle("active", isActive);
      image.style.display = isActive ? "block" : "none";
    });
    thumbnails.forEach((thumbnail, thumbnailIndex) => {
      thumbnail.classList.toggle("active", thumbnailIndex === index);
    });

    currentIndex = index;
    thumbnails[index].scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center",
    });

    updateArrowStates();
  }

  function changeImageByOffset(offset) {
    if (visibleIndexes.length <= 1) return;
    const currentVisibleIndex = visibleIndexes.indexOf(currentIndex);
    const nextVisibleIndex =
      (currentVisibleIndex + offset + visibleIndexes.length) %
      visibleIndexes.length;
    changeImage(visibleIndexes[nextVisibleIndex]);
  }

  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      changeImage(index);
    }, true);
  });

  prevArrow.addEventListener("click", function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    changeImageByOffset(-1);
  }, true);

  nextArrow.addEventListener("click", function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    changeImageByOffset(1);
  }, true);

  function getImageFilename(image) {
    const imageUrl = (image.src || image.dataset.src || "").split("?")[0];
    return imageUrl.split("/").pop();
  }

  function filterByColor(color, variantImage) {
    const normalizedColor = (color || "").trim().toLocaleLowerCase();
    if (!normalizedColor) return false;
    if (variantImage?.src) currentVariantImage = variantImage;

    const colorIndexes = mainImages.reduce((indexes, image, index) => {
      if ((image.dataset.mediaColor || "").trim().toLocaleLowerCase() === normalizedColor) {
        indexes.push(index);
      }
      return indexes;
    }, []);

    if (!colorIndexes.length) return false;

    const variantFilename = variantImage?.src
      ? variantImage.src.split("?")[0].split("/").pop()
      : "";
    const featuredImageIndex = mainImages.findIndex(
      (image) => variantFilename && getImageFilename(image) === variantFilename,
    );

    visibleIndexes = [...new Set([
      ...colorIndexes,
      ...(featuredImageIndex >= 0 ? [featuredImageIndex] : []),
    ])].sort((firstIndex, secondIndex) => firstIndex - secondIndex);

    mainImages.forEach((image, index) => {
      const isVisible = visibleIndexes.includes(index);
      image.hidden = !isVisible;
      if (!isVisible) image.style.display = "none";
    });
    thumbnails.forEach((thumbnail, index) => {
      const isVisible = visibleIndexes.includes(index);
      thumbnail.hidden = !isVisible;
      thumbnail.style.display = isVisible ? "" : "none";
      if (!isVisible) thumbnail.classList.remove("active");
    });

    const targetIndex = visibleIndexes.includes(featuredImageIndex)
      ? featuredImageIndex
      : visibleIndexes[0];
    changeImage(targetIndex);
    updateArrowStates();
    return true;
  }

  const selectedColor = document.querySelector(
    '.simple-variant-picker__option.option--color input[type="radio"]:checked',
  );
  if (!filterByColor(selectedColor?.value, null)) {
    changeImage(currentIndex);
    updateArrowStates();
  }

  window.changeImage = changeImage;
  window.filterShopProductGalleryByColor = filterByColor;

  const imageContainer = document.querySelector(".shop-main-image-wrapper");
  let touchStartX = null;
  if (imageContainer) {
    imageContainer.addEventListener("touchstart", function (event) {
      touchStartX = event.changedTouches[0]?.screenX ?? null;
      event.stopImmediatePropagation();
    }, true);
    imageContainer.addEventListener("touchend", function (event) {
      const touchEndX = event.changedTouches[0]?.screenX ?? null;
      event.stopImmediatePropagation();
      if (touchStartX === null || touchEndX === null) return;
      const distance = touchEndX - touchStartX;
      if (Math.abs(distance) >= 30) changeImageByOffset(distance < 0 ? 1 : -1);
      touchStartX = null;
    }, true);
  }

  document.addEventListener("keydown", function (event) {
    const targetTagName = document.activeElement?.tagName;
    if (["INPUT", "SELECT", "TEXTAREA"].includes(targetTagName)) return;
    if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
      event.preventDefault();
      event.stopImmediatePropagation();
      changeImageByOffset(event.key === "ArrowLeft" ? -1 : 1);
    }
  }, true);

  window.addEventListener("resize", function () {
    window.clearTimeout(window.shopProductGalleryResizeTimer);
    window.shopProductGalleryResizeTimer = window.setTimeout(function () {
      const selectedColorRadio = document.querySelector(
        '.simple-variant-picker__option.option--color input[type="radio"]:checked',
      );
      filterByColor(selectedColorRadio?.value, currentVariantImage);
    }, 250);
  });
}

function updateGalleryWithVariantImage(variantImage) {
  const carouselImages = Array.from(document.querySelectorAll(".shop-main-image"));
  const variantFilename = variantImage?.src
    ? variantImage.src.split("?")[0].split("/").pop()
    : "";
  const matchingImageIndex = carouselImages.findIndex((image) => {
    const imageUrl = (image.src || image.dataset.src || "").split("?")[0];
    return variantFilename && imageUrl.split("/").pop() === variantFilename;
  });

  if (matchingImageIndex >= 0 && typeof window.changeImage === "function") {
    window.changeImage(matchingImageIndex);
  }
}
